import type { DemBlockedFilter } from '../../lib/demCustomers';

export type DemStatusFilter = Exclude<DemBlockedFilter, 'none'>;

type DemCustomerFiltersProps = {
  value: DemStatusFilter;
  onChange: (value: DemStatusFilter) => void;
  /** Optional — DEM Items: only rows with no product photo. */
  showNoImage?: boolean;
  onShowNoImageChange?: (value: boolean) => void;
};

export function DemCustomerFilters({
  value,
  onChange,
  showNoImage,
  onShowNoImageChange,
}: DemCustomerFiltersProps) {
  return (
    <div className="dem-customer-filters" role="group" aria-label="Status filters">
      <label className="dem-customer-filters__field">
        <span className="dem-customer-filters__label">Show</span>
        <select
          className="field-input dem-customer-filters__select"
          value={value}
          onChange={(e) => onChange(e.target.value as DemStatusFilter)}
          aria-label="Show status"
        >
          <option value="all">All</option>
          <option value="unblocked">Unblocked</option>
          <option value="blocked">Blocked</option>
        </select>
      </label>
      {onShowNoImageChange ? (
        <button
          type="button"
          className={`dem-filter-btn${showNoImage ? ' dem-filter-btn--active' : ''}`}
          aria-pressed={Boolean(showNoImage)}
          onClick={() => onShowNoImageChange(!showNoImage)}
        >
          No image
        </button>
      ) : null}
    </div>
  );
}

/** @deprecated Prefer DemStatusFilter dropdown; kept for transitional callers. */
export function resolveBlockedFilter(showUnblocked: boolean, showBlocked: boolean): DemBlockedFilter {
  if (showUnblocked && showBlocked) return 'all';
  if (showUnblocked) return 'unblocked';
  if (showBlocked) return 'blocked';
  return 'none';
}
